import React, { useState, FC } from 'react';
import { Box } from '@mui/material';

import { Day } from './day';
import { Week } from './week';
import { Month } from './month';
import { Listing } from './table';
import { CalendarView } from '../types';
import { useEventIdParam } from '../hooks';
import { CalendarEventCard } from './card';
import { CalendarPanel } from './CalendarPanel';
import { CalendarLayout } from './CalendarLayout';

export const CalendarContainer = () => {
  const { eventId } = useEventIdParam();

  const [view, setView] = useState<CalendarView>(CalendarView.Month);

  const renderNestedSectionByMode: Record<CalendarView, FC<any>> = {
    [CalendarView.Day]: Day,
    [CalendarView.Week]: Week,
    [CalendarView.Month]: Month,
    [CalendarView.Table]: Listing,
  };

  const ViewComponent = renderNestedSectionByMode[view];

  return (
    <>
      {eventId && <CalendarEventCard id={eventId} />}

      <CalendarLayout>
        <CalendarPanel view={view} setView={setView} />

        <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
          <ViewComponent />
        </Box>
      </CalendarLayout>
    </>
  );
};
